<template>
  <div>
    <button class="todo-check" @click="toDoClicked()" :class="{ 'checked' : isDone }" v-if="!processing">
      <i class="fas fa-check"></i>
    </button>
    <div class="spinning-loader active" v-else></div>
  </div>
</template>

<script>
const axios = require('axios')

// endpoints
const apiChoice = process.env.VUE_APP_API_URL

export default {
  name: 'DatesList',
  props: {
    done: {
      type: String,
      default: ''
    },
    zid: {
      type: String
    },
    zshotid: {
      type: String
    },
    appshotidprop: {
      type: Number,
      default: 0
    },
    jwt: {
      type: String
    }
  },
  watch: {
    done: function () {
      this.setDone()
    },
    appshotidprop: function () {
      this.setDone()
    }
  },
  data () {
    return {
      processing: false,
      isDone: '',
      appshotid: 0
    }
  },
  components: {},
  created () {
    this.setDone()
  },
  mounted () {},
  computed: {},
  methods: {
    setDone () {
      // this.isDone = this.done
      this.isDone = this.done
      this.appshotid = this.appshotidprop
    },
    toDoClicked () {
      console.log(this.appshotid)
      if (this.appshotid) {
        this.putToDo()
      } else {
        this.postToDo()
      }
    },
    postToDo () {
      this.processing = true
      let shotData = {
        'title': 'zoho todo',
        'location': '',
        'event_id': this.zid,
        'day_id': this.zshotid,
        'extraone': '1'
      }
      // if it's currently done, swap it
      if (this.isDone) {
        shotData.extraone = ''
      }
      axios
        .post(apiChoice + 'api/shots', shotData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.jwt
          }
        })
        .then((response) => {
          // wait to change isDone via response for authenticity
          this.isDone = response.data.extraone
          this.appshotid = response.data.id
          this.$emit('checkMarked', response.data)
          // stop loading
          this.processing = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    },
    putToDo () {
      this.processing = true
      let shotData = { 'extraone': '1' }
      if (this.isDone) {
        shotData = { 'extraone': '' }
      }
      axios
        .put(apiChoice + 'api/shots/' + this.appshotid, shotData, {
          headers: {
            'Cache-Control': 'no-cache',
            'Authorization': 'Bearer ' + this.jwt
          }
        })
        .then((response) => {
          this.isDone = response.data.extraone
          this.$emit('checkMarked', response.data)
          // stop loading
          this.processing = false
        })
        .catch((error) => {
          console.log('error occurred')
          console.log(error)
          this.output = error.response.data
          // this.isLoading = false
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.todo-check{
  cursor: pointer;
  width: 28px;
  height: 28px;
  background: none;
  border: solid 2px #d7d8db;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  .fa-check{
    font-size: 14px;
    display: none;
  }
  &.checked{
    background: #00ae8b;
    border-color: #00ae8b;
    .fa-check{
      color: white;
      display: block;
    }
  }
}
.spinning-loader{
  width: 28px;
  height: 28px;
  border-width: 3px;
}
// Media Queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}
// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}
// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
